/* Source: /home/ubuntu/libredraw/frontend/pages/NotFoundPage.cl.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { useNavigate } from "@jac/runtime";
function NotFoundPage() {
  let navigate = useNavigate();
  return __jacJsx("div", {"className": "flex min-h-screen flex-col items-center justify-center gap-4 bg-background px-6 text-center"}, [__jacJsx("img", {"src": "/assets/logo.png", "alt": "LibreDraw", "className": "size-12"}, []), __jacJsx("div", {"className": "flex flex-col gap-1"}, [__jacJsx("h1", {"className": "text-2xl font-semibold text-foreground"}, ["Page not found"]), __jacJsx("p", {"className": "max-w-sm text-sm text-muted-foreground"}, ["The page you're looking for doesn't exist or has moved."])]), __jacJsx("div", {"className": "flex gap-2"}, [__jacJsx("button", {"onClick": _e => {
    navigate("/canvas");
  }, "className": "rounded-lg bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90"}, ["Open the editor"]), __jacJsx("button", {"onClick": _e => {
    navigate("/dashboard");
  }, "className": "rounded-lg border border-border px-4 py-2 text-sm font-medium hover:bg-accent"}, ["My diagrams"])])]);
}
/*jac:refresh-boundary*/;
export {NotFoundPage};
//# sourceMappingURL=NotFoundPage.js.map
